var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavriteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99398 2.09755C8.04406 0.393473 5.16035 0.0447587 2.92093 1.95817C0.498605 4.02785 0.146663 7.51353 2.06218 9.9784C2.78928 10.914 4.20844 12.3197 5.57229 13.607C6.9521 14.9094 8.32872 16.1401 9.00761 16.7413L9.02053 16.7527C9.08436 16.8093 9.16383 16.8797 9.24 16.9371C9.33121 17.0058 9.46213 17.0911 9.63696 17.1432C9.86939 17.2125 10.1192 17.2125 10.3517 17.1432C10.5265 17.0911 10.6574 17.0058 10.7486 16.9371C10.8248 16.8797 10.9043 16.8093 10.9681 16.7527L10.981 16.7413C11.6599 16.1401 13.0365 14.9094 14.4163 13.607C15.7802 12.3197 17.1993 10.914 17.9264 9.9784C19.8346 7.523 19.537 4.01044 17.059 1.95086C14.7946 0.0688381 11.9417 0.392824 9.99398 2.09755ZM9.36104 3.82158C7.94015 2.16044 5.68159 1.79158 4.00359 3.2253C2.25083 4.72289 2.01498 7.20154 3.37818 8.95571C4.01409 9.77399 5.33892 11.0949 6.7163 12.395C8.00217 13.6087 9.28841 14.7622 9.99431 15.3887C10.7002 14.7622 11.9864 13.6087 13.2723 12.395C14.6497 11.0949 15.9745 9.77399 16.6104 8.95571C17.981 7.19207 17.7625 4.70278 15.9937 3.2326C14.2712 1.80099 12.0422 2.16778 10.6276 3.82158C10.4693 4.00667 10.2379 4.11323 9.99431 4.11323C9.75074 4.11323 9.51936 4.00667 9.36104 3.82158Z",
    fill: "#475467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavriteIcon);
export default __webpack_public_path__ + "static/media/favrite-icon.7e0172a3ae267f7bb489d2cbf4d44add.svg";
export { ForwardRef as ReactComponent };